module.exports = __webpack_public_path__ + "media/images/flags/16/Trinidad-and-Tobago-30e3f4b4622bd0647cb5717584fd6155.png";